import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-slate-800 bg-slate-950 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-75" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-76" data-mp="9t1n35sxkbb0">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-77" data-mp="etpl4bfktseq">
          <span className="inline-flex rounded-full bg-orange-500/10 p-4 text-orange-400" data-id="element-78" data-mp="nrrk6lfr2azd">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-79" data-mp="smxeo8n7wxz2" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-80" data-mp="xj5pj9udu50f">
            7-Day <span className="text-amber-400" data-id="element-81" data-mp="12h77tsjzi0au">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-82" data-mp="17imrbg6ijyr4">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs in underground mining and mine operations,{' '}
            <span className="font-semibold text-white" data-id="element-83" data-mp="1vt7p8oy9kzg3">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}